/*
 * @Author: guoyu
 * @Date: 2020-05-08 17:14:40
 * @LastEditors: your name
 * @LastEditTime: 2020-05-09 14:05:00
 * @Description: 通用的弹窗属性（配合mixins使用）
 */
export default {
  model: {
    event: 'close',
    prop: 'show',
  },
  props: {
    show: { type: Boolean, default: false },
  },
  computed: {
    popupShow: {
      get() {
        return this.show;
      },
      set(newVal) {
        this.$emit('close', newVal);
      },
    },
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
  },
};
